import React, { useState } from 'react';
import {
  Button,
  Box,
  Avatar,
  Menu,
  MenuItem,
  Divider,
  ListItemIcon,
  ListItemText,
  Tooltip
} from '@mui/material';
import {
  Login as LoginIcon,
  Logout as LogoutIcon,
  AccountCircle as AccountIcon,
  WorkspacePremium as VipIcon
} from '@mui/icons-material';
import { useAuth } from '../contexts/AuthContext';
import LoginModal from './LoginModal';
import VipSubscriptionModal from './VipSubscriptionModal';

const AuthButton = ({ isMobile = false }) => {
  const { user, logout } = useAuth();
  const [anchorEl, setAnchorEl] = useState(null);
  const [loginModalOpen, setLoginModalOpen] = useState(false);
  const [vipModalOpen, setVipModalOpen] = useState(false);

  const open = Boolean(anchorEl);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLoginClick = () => {
    setLoginModalOpen(true);
    handleMenuClose();
  };

  const handleLogoutClick = () => {
    logout();
    handleMenuClose();
  };

  const handleVipSubscriptionClick = () => {
    handleMenuClose();
    setVipModalOpen(true);
  };

  const handleVipModalClose = () => {
    setVipModalOpen(false);
  };

  const handleLoginModalClose = () => {
    setLoginModalOpen(false);
  };

  return (
    <>
      <Box
        sx={{
          p: isMobile ? 1.5 : 1,
          borderTop: '0',
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'center',
          minHeight: isMobile ? '64px' : '60px',
          maxHeight: isMobile ? '64px' : '60px',
          width: '100%',
          overflow: 'hidden'
        }}
      >
        {user ? (
          <Button
            onClick={handleMenuOpen}
            sx={{
              width: '100%',
              minWidth: isMobile ? '48px' : '40px',
              p: isMobile ? 1.5 : 1,
              borderRadius: 2,
              display: 'flex',
              justifyContent: 'flex-start',
              alignItems: 'center',
              textTransform: 'none',
              color: 'text.primary',
            }}
          >
            <Avatar
              sx={{
                width: isMobile ? 32 : 28,
                height: isMobile ? 32 : 28,
                fontSize: isMobile ? 14 : 12,
                mr: 1,
              }}
              src={user.avatar}
            >
              {user.username.charAt(0).toUpperCase()}
            </Avatar>
            <Box sx={{
              textAlign: 'left',
              fontSize: isMobile ? '0.95rem' : '0.875rem',
              fontWeight: 500,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}>
              {user.username}
            </Box>
          </Button>
        ) : (
          <Button
            onClick={handleLoginClick}
            startIcon={<LoginIcon />}
            sx={{
              width: '100%',
              minWidth: isMobile ? '48px' : '40px',
              p: isMobile ? 1.5 : 1,
              borderRadius: 2,
              justifyContent: 'flex-start',
              textTransform: 'none',
              color: 'text.primary',
              '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.04)'
              },
              fontSize: isMobile ? '0.95rem' : '0.875rem',
            }}
          >
            登录
          </Button>
        )}
      </Box>

      {user && (
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleMenuClose}
          onClick={handleMenuClose}
          PaperProps={{
            elevation: 0,
            sx: {
              overflow: 'visible',
              filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
              mt: 1.5,
              minWidth: isMobile ? 160 : 200,
              width: 'auto',
              maxWidth: 280,
              '& .MuiAvatar-root': {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
            },
          }}
          transformOrigin={{ horizontal: 'right', vertical: 'top' }}
          anchorOrigin={{ horizontal: isMobile ? 'left' : 'right', vertical: 'bottom' }}
        >
          <MenuItem>
            <ListItemIcon>
              <AccountIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>
              <Box sx={{ fontWeight: 500 }}>{user.username}</Box>
            </ListItemText>
          </MenuItem>
          <Divider />

          <MenuItem onClick={handleVipSubscriptionClick}>
            <ListItemIcon>
              <VipIcon fontSize="small" />
            </ListItemIcon>
            订阅
          </MenuItem>
          <MenuItem onClick={handleLogoutClick}>
            <ListItemIcon>
              <LogoutIcon fontSize="small" />
            </ListItemIcon>
            登出
          </MenuItem>
        </Menu>
      )}

      <LoginModal
        open={loginModalOpen}
        onClose={handleLoginModalClose}
      />

      <VipSubscriptionModal
        open={vipModalOpen}
        onClose={handleVipModalClose}
      />
    </>
  );
};

export default AuthButton;
